<div class="flex min-h-screen flex-col bg-slate-50">
  <div class="mx-auto w-full max-w-6xl flex-1 px-4 py-8 sm:px-6 lg:px-8">

    <a
      (click)="goBack()"
      class="mb-6 inline-flex cursor-pointer items-center gap-2 text-sm font-medium text-slate-500 transition-colors hover:text-slate-900"
    >
      <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
      </svg>
      {{ fromHistory() ? '返回历史记录' : '返回写作' }}
    </a>

    @if (combination(); as c) {

      <!-- ── Overall Score Banner ── -->
      <section class="mb-6 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <div class="flex flex-col items-center gap-4 px-6 py-6 sm:flex-row sm:justify-between">
          <div class="flex items-center gap-4">
            <div class="flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-600 shadow-md">
              <svg class="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0" />
              </svg>
            </div>
            <div>
              <div class="flex items-center gap-2">
                <p class="text-lg font-medium text-slate-400">{{ c.year }}年{{ c.month }}月 · 组合 {{ c.combinationNumber }}</p>
                <button
                  type="button"
                  (click)="goToPractice(c)"
                  class="rounded-md border border-blue-600 bg-white px-2.5 py-1 text-xs font-semibold text-blue-600 transition-colors hover:bg-blue-50"
                >
                  练习
                </button>
              </div>
              <!-- <p class="text-sm font-medium text-slate-500">预估总分</p>
              <p class="text-3xl font-bold text-blue-600">{{ estimatedNclc() }}</p> -->
            </div>
          </div>
          <div class="flex flex-wrap justify-center gap-2 sm:justify-end">
            @for (graded of isTaskGraded(); track $index) {
              <span
                class="inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-semibold"
                [class]="getTaskBadgeClass(graded)"
              >
                @if (graded) {
                  <svg class="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" /></svg>
                } @else {
                  <svg class="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 20 20"><path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" /></svg>
                }
                Tâche {{ $index + 1 }}: {{ graded ? '已评分' : '未完成' }}
              </span>
            }
          </div>
        </div>
      </section>

      <!-- ── Task Tabs ── -->
      <div class="mb-6 flex gap-1 rounded-xl border border-slate-200 bg-white p-1 shadow-sm">
        @for (task of [1, 2, 3]; track task; let i = $index) {
          <button
            type="button"
            class="flex-1 rounded-lg px-4 py-2.5 text-sm font-semibold transition-all focus:outline-none"
            [class.bg-blue-600]="activeTaskIndex() === i"
            [class.text-white]="activeTaskIndex() === i"
            [class.shadow-sm]="activeTaskIndex() === i"
            [class.text-slate-500]="activeTaskIndex() !== i"
            [class.hover:bg-slate-100]="activeTaskIndex() !== i"
            (click)="setActiveTask(i)"
          >
            Tâche {{ task }}
          </button>
        }
      </div>

      <!-- ── Task Question (with rich layout for Tâche 3) ── -->
      @if (activePrompt(); as prompt) {
        <div class="mb-6 rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
          <div class="mb-3 flex items-center gap-2">
            <svg class="h-4 w-4 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
            </svg>
            <h2 class="text-sm font-bold uppercase tracking-wide text-slate-500">题目</h2>
          </div>

          @if (activeTaskIndex() === 2 && activeDocuments().length) {
            <div class="space-y-3">
              <!-- Task title / main theme above documents -->
              <p class="whitespace-pre-wrap text-sm font-medium leading-relaxed text-slate-800">
                {{ prompt }}
              </p>

              <!-- Document 1 & 2, full width -->
              @for (doc of activeDocuments(); track $index) {
                <div class="rounded-lg border border-blue-100 bg-blue-50/70 p-3.5">
                  <div class="mb-1 flex items-center gap-2">
                    <span
                      class="inline-flex items-center justify-center rounded-full bg-blue-600 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-white"
                    >
                      Document {{ $index + 1 }}
                    </span>
                  </div>
                  <p class="text-sm leading-relaxed text-slate-800">
                    {{ doc }}
                  </p>
                </div>
              }
            </div>
          } @else {
            <p class="whitespace-pre-wrap text-sm leading-relaxed text-slate-700">
              {{ prompt }}
            </p>
          }
        </div>
      }

      @if (isActiveTaskGraded()) {
        @if (activeTaskResult(); as result) {

          <!-- ── Score Indicators ── -->
          <div class="mb-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
            <div class="flex flex-col items-center gap-1 rounded-xl border border-slate-200 bg-white px-4 py-4 shadow-sm">
              <span class="text-xs font-semibold uppercase tracking-wide text-slate-400">NCLC 评级</span>
              <span class="text-xl font-bold text-blue-600">{{ result.nclcLevel }}</span>
            </div>
            <div class="flex flex-col items-center gap-1 rounded-xl border border-slate-200 bg-white px-4 py-4 shadow-sm">
              <span class="text-xs font-semibold uppercase tracking-wide text-slate-400">字数</span>
              <span
                class="text-xl font-bold"
                [class.text-emerald-600]="result.wordCount >= result.wordLimit.min && result.wordCount <= result.wordLimit.max"
                [class.text-rose-600]="result.wordCount < result.wordLimit.min || result.wordCount > result.wordLimit.max"
              >{{ result.wordCount }}</span>
              <span class="text-xs text-slate-400">{{ result.wordLimit.min }}–{{ result.wordLimit.max }} 词</span>
            </div>
            <div class="flex flex-col items-center gap-1 rounded-xl border border-slate-200 bg-white px-4 py-4 shadow-sm">
              <span class="text-xs font-semibold uppercase tracking-wide text-slate-400">语法错误</span>
              <span
                class="text-xl font-bold"
                [class.text-emerald-600]="result.grammarErrors.length === 0"
                [class.text-rose-600]="result.grammarErrors.length > 0"
              >{{ result.grammarErrors.length }}</span>
              <span class="text-xs text-slate-400">处需修正</span>
            </div>
            <div class="flex flex-col items-center gap-1 rounded-xl border border-slate-200 bg-white px-4 py-4 shadow-sm">
              <span class="text-xs font-semibold uppercase tracking-wide text-slate-400">高分句型</span>
              <span class="text-xl font-bold text-amber-500">{{ result.highScoringPatternsFound.length }}</span>
              <span class="text-xs text-slate-400">已掌握</span>
            </div>
          </div>

          <!-- ── Side-by-Side Writing Comparison ── -->
          <div class="mb-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
            <div class="flex flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
              <div class="flex items-center justify-between border-b border-slate-100 bg-slate-50/60 px-5 py-3">
                <h3 class="flex items-center gap-2 text-sm font-bold text-slate-700">
                  <svg class="h-4 w-4 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125" />
                  </svg>
                  您的原文
                </h3>
                <span
                  class="rounded-full border px-2.5 py-0.5 text-xs font-semibold"
                  [class.border-emerald-200]="result.wordCount >= result.wordLimit.min && result.wordCount <= result.wordLimit.max"
                  [class.bg-emerald-50]="result.wordCount >= result.wordLimit.min && result.wordCount <= result.wordLimit.max"
                  [class.text-emerald-700]="result.wordCount >= result.wordLimit.min && result.wordCount <= result.wordLimit.max"
                  [class.border-rose-200]="result.wordCount < result.wordLimit.min || result.wordCount > result.wordLimit.max"
                  [class.bg-rose-50]="result.wordCount < result.wordLimit.min || result.wordCount > result.wordLimit.max"
                  [class.text-rose-700]="result.wordCount < result.wordLimit.min || result.wordCount > result.wordLimit.max"
                >
                  {{ result.wordCount }} 词
                </span>
              </div>
              <div class="break-words flex-1 p-5 text-sm leading-relaxed text-slate-800">
                @for (seg of result.originalSegments; track $index) {
                  @if (seg.type === 'deleted') {
                    <span class="rounded-sm bg-rose-100 px-0.5 text-rose-800 line-through">{{ seg.text }}</span>
                  } @else {
                    <span>{{ seg.text }}</span>
                  }
                  <span> </span>
                }
              </div>
            </div>

            <div class="flex flex-col overflow-hidden rounded-xl border border-emerald-200 bg-white shadow-sm">
              <div class="flex items-center justify-between border-b border-emerald-100 bg-emerald-50/40 px-5 py-3">
                <h3 class="flex items-center gap-2 text-sm font-bold text-emerald-800">
                  <svg class="h-4 w-4 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  AI 修改版
                </h3>
                <span class="rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-0.5 text-xs font-semibold text-emerald-700">
                  B2 / C1 水平
                </span>
              </div>
              <div class="break-words flex-1 p-5 text-sm leading-relaxed text-slate-800">
                @for (seg of result.correctedSegments; track $index) {
                  @if (seg.type === 'inserted') {
                    <span class="rounded-sm bg-emerald-100 px-0.5 font-medium text-emerald-900">{{ seg.text }}</span>
                  } @else {
                    <span>{{ seg.text }}</span>
                  }
                  <span> </span>
                }
              </div>
              <div class="border-t border-emerald-100 bg-emerald-50/30 px-5 py-3">
                <p class="text-xs text-emerald-700">
                  <span class="font-semibold">任务完成度：</span>{{ result.taskFulfillment }}
                </p>
              </div>
            </div>
          </div>

          <!-- ── 高分句型 Panel ── -->
          @if (result.highScoringPatternsFound.length > 0 || result.suggestedPatterns.length > 0) {
            <div class="mb-6 overflow-hidden rounded-xl border border-amber-200 bg-white shadow-sm">
              <div class="border-b border-amber-200 bg-gradient-to-r from-amber-50 to-yellow-50 px-5 py-4">
                <h3 class="flex items-center gap-2 text-sm font-bold text-amber-800">
                  <svg class="h-5 w-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
                  </svg>
                  高分句型分析
                </h3>
                <p class="mt-0.5 text-xs text-amber-600">识别您已掌握的高级句型，并提供精准升级建议</p>
              </div>
              <div class="grid grid-cols-1 gap-0 divide-y divide-amber-100 lg:grid-cols-2 lg:divide-x lg:divide-y-0">

                <!-- Left: Patterns Already Used -->
                <div class="p-5">
                  <div class="mb-4 flex items-center gap-2">
                    <span class="flex h-6 w-6 items-center justify-center rounded-full bg-emerald-100">
                      <svg class="h-3.5 w-3.5 text-emerald-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
                      </svg>
                    </span>
                    <h4 class="text-sm font-bold text-slate-700">你已掌握的高分句型</h4>
                    <span class="ml-auto rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-bold text-emerald-700">{{ result.highScoringPatternsFound.length }} 个</span>
                  </div>
                  @if (result.highScoringPatternsFound.length === 0) {
                    <p class="rounded-lg bg-slate-50 p-4 text-center text-sm text-slate-400">暂未检测到高分句型，继续加油！</p>
                  } @else {
                    <div class="space-y-3">
                      @for (pattern of result.highScoringPatternsFound; track pattern.patternName) {
                        <div class="rounded-lg border border-emerald-100 bg-emerald-50/50 p-3.5">
                          <div class="mb-2 flex items-center gap-2">
                            <span class="rounded-full border border-emerald-300 bg-white px-2.5 py-0.5 text-xs font-bold text-emerald-700">{{ pattern.patternName }}</span>
                          </div>
                          <p class="mb-1.5 font-mono text-sm italic text-slate-700">"{{ pattern.excerpt }}"</p>
                          <p class="text-xs leading-relaxed text-slate-600">{{ pattern.explanation }}</p>
                        </div>
                      }
                    </div>
                  }
                </div>

                <!-- Right: Suggested Upgrades -->
                <div class="p-5">
                  <div class="mb-4 flex items-center gap-2">
                    <span class="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100">
                      <svg class="h-3.5 w-3.5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18" />
                      </svg>
                    </span>
                    <h4 class="text-sm font-bold text-slate-700">升级建议 Level Up</h4>
                    <span class="ml-auto rounded-full bg-blue-100 px-2 py-0.5 text-xs font-bold text-blue-700">{{ result.suggestedPatterns.length }} 条</span>
                  </div>
                  @if (result.suggestedPatterns.length === 0) {
                    <p class="rounded-lg bg-slate-50 p-4 text-center text-sm text-slate-400">暂无升级建议</p>
                  } @else {
                    <div class="space-y-4">
                      @for (pattern of result.suggestedPatterns; track pattern.patternName) {
                        <div class="rounded-lg border border-blue-100 bg-blue-50/40 p-3.5">
                          <span class="mb-2.5 inline-block rounded-full border border-blue-300 bg-white px-2.5 py-0.5 text-xs font-bold text-blue-700">{{ pattern.patternName }}</span>
                          <div class="space-y-1.5">
                            <div class="flex items-start gap-2">
                              <span class="mt-0.5 shrink-0 rounded bg-rose-100 px-1.5 py-0.5 text-xs font-bold text-rose-600">原句</span>
                              <p class="font-mono text-xs italic text-slate-600">{{ pattern.originalSentence }}</p>
                            </div>
                            <div class="flex items-start gap-2">
                              <span class="mt-0.5 shrink-0 rounded bg-emerald-100 px-1.5 py-0.5 text-xs font-bold text-emerald-700">升级</span>
                              <p class="font-mono text-xs font-semibold italic text-emerald-800">{{ pattern.improvedSentence }}</p>
                            </div>
                          </div>
                          <p class="mt-2 text-xs leading-relaxed text-slate-600">{{ pattern.explanation }}</p>
                        </div>
                      }
                    </div>
                  }
                </div>

              </div>
            </div>
          }

          <!-- ── Detailed Feedback Sections ── -->
          <div class="space-y-4">

            <!-- Grammar Corrections -->
            <div class="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
              <div class="flex items-center justify-between border-b border-slate-100 bg-slate-50/60 px-5 py-4">
                <h3 class="flex items-center gap-2 text-sm font-bold text-slate-700">
                  <svg class="h-4 w-4 text-rose-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                  </svg>
                  语法纠正
                </h3>
                <span class="rounded-full bg-rose-50 px-2.5 py-0.5 text-xs font-bold text-rose-600">{{ result.grammarErrors.length }} 处</span>
              </div>
              <div class="p-5">
                @if (result.grammarErrors.length === 0) {
                  <p class="text-center text-sm text-emerald-600">太棒了！未发现语法错误。</p>
                } @else {
                  <div class="space-y-3">
                    @for (err of result.grammarErrors; track err.original) {
                      <div class="rounded-lg border border-slate-100 bg-slate-50/50 p-4">
                        <div class="flex flex-wrap items-center gap-2 text-sm">
                          <span class="font-semibold text-rose-600 line-through decoration-rose-400">{{ err.original }}</span>
                          <svg class="h-4 w-4 shrink-0 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/></svg>
                          <span class="font-semibold text-emerald-600">{{ err.correction }}</span>
                        </div>
                        <p class="mt-2 text-xs leading-relaxed text-slate-600">{{ err.explanation }}</p>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>

            <!-- Vocabulary Upgrades -->
            <div class="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
              <div class="flex items-center justify-between border-b border-slate-100 bg-slate-50/60 px-5 py-4">
                <h3 class="flex items-center gap-2 text-sm font-bold text-slate-700">
                  <svg class="h-4 w-4 text-violet-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
                  </svg>
                  词汇提升
                </h3>
                <span class="rounded-full bg-violet-50 px-2.5 py-0.5 text-xs font-bold text-violet-600">{{ result.vocabularyUpgrades.length }} 个</span>
              </div>
              <div class="p-5">
                @if (result.vocabularyUpgrades.length === 0) {
                  <p class="text-center text-sm text-emerald-600">词汇运用出色，无需调整。</p>
                } @else {
                  <div class="space-y-2.5">
                    @for (v of result.vocabularyUpgrades; track v.original) {
                      <div class="rounded-lg border border-slate-100 bg-slate-50/50 p-3.5">
                        <div class="flex flex-wrap items-center gap-2 text-sm">
                          <span class="text-slate-500 line-through">{{ v.original }}</span>
                          <svg class="h-3.5 w-3.5 shrink-0 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/></svg>
                          <span class="font-bold text-violet-700">{{ v.suggestion }}</span>
                        </div>
                        @if (v.reason) {
                          <p class="mt-1.5 text-xs text-slate-500">{{ v.reason }}</p>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>

            <!-- Connectors -->
            <div class="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
              <div class="border-b border-slate-100 bg-slate-50/60 px-5 py-4">
                <h3 class="flex items-center gap-2 text-sm font-bold text-slate-700">
                  <svg class="h-4 w-4 text-teal-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                  </svg>
                  逻辑连词
                </h3>
              </div>
              <div class="space-y-5 p-5">
                <div>
                  <p class="mb-3 text-xs font-bold uppercase tracking-wider text-slate-400">已使用 ({{ result.connectorsUsed.length }})</p>
                  @if (result.connectorsUsed.length === 0) {
                    <p class="text-xs text-slate-400">未检测到逻辑连词</p>
                  } @else {
                    <div class="flex flex-wrap gap-2">
                      @for (conn of result.connectorsUsed; track conn) {
                        <span class="rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700">{{ conn }}</span>
                      }
                    </div>
                  }
                </div>
                <div>
                  <p class="mb-3 text-xs font-bold uppercase tracking-wider text-slate-400">建议补充</p>
                  @if (result.connectorsMissed.length === 0) {
                    <p class="text-xs text-slate-400">连词使用已很丰富！</p>
                  } @else {
                    <div class="flex flex-wrap gap-2">
                      @for (conn of result.connectorsMissed; track conn) {
                        <span class="rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-xs font-semibold text-amber-700">{{ conn }}</span>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>

          </div>
        }

      } @else {
        <div class="overflow-hidden rounded-xl border border-amber-200 bg-amber-50 shadow-sm">
          <div class="p-6">
            <div class="mb-3 flex items-center gap-3 text-amber-800">
              <svg class="h-6 w-6 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
              <h3 class="text-base font-bold">未评分 (Unscored)</h3>
            </div>
            <p class="mb-6 max-w-3xl text-sm leading-relaxed text-amber-700">
              您的作答字数为 <strong>{{ activeTaskResult().wordCount || 0 }} 词</strong>。TCF Canada 要求至少达到最低字数标准
              (<strong>{{ activeTaskResult().wordLimit.min }} 词</strong>) 才能进行有效评分。系统已跳过此题的 AI 批改以帮您节省配额。
            </p>
            <div class="rounded-lg border border-amber-200/60 bg-white/60 p-5">
              <p class="mb-2 text-xs font-bold uppercase tracking-wider text-amber-800">您的草稿</p>
              <div class="whitespace-pre-wrap font-mono text-sm text-slate-600">{{ activeTaskResult().originalText || '（无内容）' }}</div>
            </div>
          </div>
        </div>
      }

    } @else {
      <div class="flex items-center justify-center py-20">
        <p class="flex items-center gap-3 text-base font-medium text-slate-500">
          <svg class="h-5 w-5 animate-spin text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
          分析中...
        </p>
      </div>
    }
  </div>
</div>
